import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "culture-reader-cnx.firebaseapp.com",
  projectId: "culture-reader-cnx",
  storageBucket: "culture-reader-cnx.appspot.com",
  messagingSenderId: "359696640446",
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);